import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useCommonAppServices } from '@provider-portal/common/services/ContextProviders';

export function PageChangeTracker() {
  const { trackingService } = useCommonAppServices();
  const location = useLocation();

  useEffect(() => {
    trackingService.pushPageChangeEvent({ url: location.pathname });
  }, [trackingService, location.pathname]);

  return null;
}
